import React from "react";

function ShippingPolicy() {
  return (
    <div className="policy-page container">
      <style>{`
        .policy-page {
          max-width: 900px;
          margin: 0 auto;
          padding: 50px 20px;
          font-family: "Helvetica Neue", Arial, sans-serif;
          color: #333;
          line-height: 1.8;
        }
        .policy-title {
          font-size: 2.2rem;
          text-align: center;
          margin-bottom: 10px;
          color: #2c2c2c;
        }
        .last-updated {
          text-align: center;
          color: #777;
          margin-bottom: 40px;
          font-size: 0.9rem;
        }
        .policy-page section {
          margin-bottom: 40px;
        }
        .policy-page h2 {
          font-size: 1.4rem;
          color: #444;
          margin-bottom: 15px;
          border-left: 4px solid #d19c65; /* Accent color */
          padding-left: 10px;
        }
        .policy-page p {
          font-size: 1rem;
          margin-bottom: 15px;
        }
        .policy-page ul {
          list-style: disc inside;
          margin-top: 10px;
        }
        .policy-page li {
          margin-bottom: 8px;
          font-size: 1rem;
        }
        @media (max-width: 768px) {
          .policy-page {
            padding: 30px 15px;
          }
          .policy-title {
            font-size: 1.8rem;
          }
          .policy-page h2 {
            font-size: 1.2rem;
          }
        }
      `}</style>

      <h1 className="policy-title">Shipping Policy</h1>
      {/* <p className="last-updated">Last updated: September 11, 2025</p> */}

      <section>
        <h2>Order Processing</h2>
        <p>
          Orders are processed within <strong>2–4 business days</strong>. Orders
          placed on weekends or holidays will be processed on the next business
          day.
        </p>
      </section>

      <section>
        <h2>Domestic Shipping</h2>
        <ul>
          <li>Standard shipping usually takes 5–7 business days.</li>
          <li>Express shipping may be available at checkout.</li>
          <li>
            Delivery times can vary depending on your location and courier
            service availability.
          </li>
        </ul>
      </section>

      <section>
        <h2>International Shipping</h2>
        <p>
          We currently offer international shipping to select countries. Shipping
          charges and delivery times will be calculated at checkout. Customers
          are responsible for customs duties, taxes, and import fees where
          applicable.
        </p>
      </section>

      <section>
        <h2>Order Tracking</h2>
        <p>
          Once your order is shipped, we will provide a tracking number via
          email or SMS. You can track your package directly on the courier’s
          website.
        </p>
      </section>

      <section>
        <h2>Delays</h2>
        <p>
          While we strive to deliver orders on time, unforeseen events such as
          weather, strikes, or courier issues may cause delays. We appreciate
          your understanding in such cases.
        </p>
      </section>

      <section>
        <h2>Incorrect Address</h2>
        <p>
          Please ensure your shipping address is accurate when placing an order.
          We are not responsible for delays or lost packages due to incorrect or
          incomplete addresses.
        </p>
      </section>

      {/* <section>
        <h2>Contact Us</h2>
        <p>
          For any questions about this Shipping Policy, please contact our
          support team:
        </p>
        <ul>
          <li>Email: support@yourwebsite.com</li>
          <li>Phone: +91-XXXXXXXXXX</li>
        </ul>
      </section> */}
    </div>
  );
}

export default ShippingPolicy;
